module.exports = __webpack_public_path__ + "static/media/1017932.34f5aeb2.png";